export default __webpack_public_path__ + "static/media/no_image.01efda4d.jpg";